import React, { useState } from 'react';
import styled from 'styled-components';
import Truncate from 'react-truncate';
import NoSsr from '@material-ui/core/NoSsr';
import { height } from 'styled-system';

import { Grid } from 'components/core';

export default function MarketingSpotlight(props) {
  const { copy, cta, header, img, label, meta = null } = props;
  const [hover, setHover] = useState(false);
  return (
    <SpotlightContainer container height={height}>
      <Content container item lg={6} md={6}>
        <div>
          <Label>{label}</Label>
          {header && <Header underline={hover}>{header}</Header>}
          {copy && (
            <Copy>
              <NoSsr>
                <Truncate lines={4}>{copy}</Truncate>
              </NoSsr>
            </Copy>
          )}
          {cta && <CTA>{cta}</CTA>}
        </div>
        {meta && meta}
      </Content>
      <ImgContainer
        item
        lg={6}
        md={6}
        className='img-container'
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        {img}
      </ImgContainer>
    </SpotlightContainer>
  );
}

const Content = styled(Grid)`
  flex-flow: column nowrap;
  justify-content: center;
  padding-left: 70px;
  padding-right: 10px;
  @media (max-width: 1180px) {
    padding: 10px 30px 48px;
  }
`;

const Copy = styled.p`
  max-width: 447px;
  font-size: 14px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.grey[35]};
  ${({ theme }) => theme.breakpoints.down(`sm`)} {
    font-size: 13px;
    line-height: 21px;
  }
`;

const CTA = styled.div`
  margin-top: 25px;
`;

const Header = styled.p`
  max-width: 467px;
  font-size: 20px;
  line-height: 24px;
  margin-bottom: 15px;
  font-weight: bold;
  color: var(--dcm-color-text-primary, ${({ theme }) => theme.colors.primaryBlack});
  ${({ underline }) => underline && `text-decoration: underline`};
  &:hover {
    text-decoration: underline;
  }
`;

const ImgContainer = styled(Grid)`
  display: flex;
  position: relative;
  clip-path: polygon(0% 100%, 100% 100%, 100% 0%, 25% 0%);
  max-height: inherit;
  @media (max-width: 959px) {
    min-height: 254px;
    clip-path: polygon(0% 83%, 100% 95%, 100% 0%, 0% 0%);
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 0 24px 24px 0;
    @media (max-width: 959px) {
      border-radius: 24px 24px 0 0;
    }
  }
`;

const Label = styled.p`
  font-size: 13px;
  line-height: 13px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.primaryGreen};
  margin-bottom: 15px;
  text-transform: uppercase;
`;

const SpotlightContainer = styled(Grid)`
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 5px 14px rgba(0, 0, 0, 0.097543);
  border-radius: 24px;
  max-width: 1236px;
  min-height: 375px;
  max-height: 475px;
  height: 100%;
  @media (max-width: 960px) {
    max-height: unset;
    flex-flow: column-reverse nowrap;
  }
`;
